export class Companys {
    orgid: number;
    companyid: number;
    companyname: string;
    createdon: string;
    // mgrid:string;
    createdby: number;
    lastupdatedon: string;
    lastupdatedby: number;
    activeflag: string;
    inoperative: string;
    companyinitial: string;
    sendmail: string;
    cinnumber: string;
    companytype: number;
    groupid: number;

    companytypelist: Array<number>;
    groupslist: Array<number>;
}

export class Departments {
    id: number;
    departmentid: number;
    orgid: number;
    departmentname: string;
    createdon: string;
    createdby: number;
    lastupdatedby: number;
    lastupdatedon: string;
    deptinitial: string;
    activeflag: string;
    editflag: "Y"

}
export class Locations {

    id: number;
    locationid: number;
    orgid: number;
    locationname: string;
    countryid: number;
    stateid: number;
    hubid: number;
    regionid: number;
    locationmodelid: number
    createdon: string;
    createdby: number;
    lastupdatedby: number;
    lastupdatedon: string;
    locationinitial: string;
    activeflag: boolean = false;
    editflag: "Y"
    locationtypelist: Array<number>;
    groupslist: Array<number>;
    country: Array<Country>;
    address: string = ''

}
export class LocationModelList {
    locationmodelid: number;
    locationmodelname: string;
}
export class Verticals {
    id: number;
    verticalid: number;
    orgid: number;
    name: string;
    createdon: string;
    createdby: number;
    lastupdatedby: number;
    lastupdatedon: string;
    //locationinitial: string;
    activeflag: string;
    editflag: "Y"
    verticaltypelist: Array<number>;
    groupslist: Array<number>;
}
export class Subverticals {
    id: number;
    subverticalid: number;
    orgid: number;
    name: string;
    createdon: string;
    createdby: number;
    lastupdatedby: number;
    lastupdatedon: string;
    //locationinitial: string;
    activeflag: string;
    editflag: "Y"
    subverticaltypelist: Array<number>;
    groupslist: Array<number>;
}


export class Groups {
    groupid: number;
    groupname: number;
    groupinitial: string;

}

export class Companytype {
    id: number;
    companytype: number;
}

export class Viewdata {
    orgid: number;
    groupid: number;
    limit: number;
    page: number;


}

export class Country {
    id: number;
    countryname: string;
    countrycode: string;

}
export class States {
    stateid: number;
    statename: string;
    createdby: number;
    createdon: String;
    lastupdatedby: number;
    lastupdateon: String;
    activeflag: string;
}

export class Regions {
    id: number;
    regionname: string;
    regionid: number;
    orgid: number;
    createdby: number;
    createdon: String;
    lastupdatedby: number;
    lastupdateon: String;
    activeflag: string;
}
export class City {
    id: number;
    cityname: string;
    cityid: number;
    orgid: number;
    createdby: number;
    createdon: String;
    lastupdatedby: number;
    lastupdateon: String;
    activeflag: string;
}
export class Hub {
    id: number;
    cityname: string;
    cityid: number;
    orgid: number;
    createdby: number;
    createdon: String;
    lastupdatedby: number;
    lastupdateon: String;
    activeflag: string;
}
export class Locationtypes {
    locationtypeid: number;
    locationtypename: string;
    createdby: number;
    createdon: String;
    lastupdatedby: number;
    lastupdateon: String;
    activeflag: string;
}
export class Users {
    id: number;
    managerid: number;
    orgid: number;
    username: string;
    createdon: string;
    createdby: number;
    lastupdatedby: number;
    lastupdatedon: string;
    emailid: string;
    role: string;
    departmentname: string;
    locationname: string;
    activeflag: string;

}
export class Countries {
    countryid: number;
    countryname: string;
    createdon: String;
    activeflag: string;
}
export class EntityType {
    entitytypeid: number;
    entitytypename: string;
    createdon: String;
    activeflag: string;
}
export class SubDepartment {
    subdepartmentid: number;
    departmentname: string;
    subdepartmentname: string;
    createdon: String;
    activeflag: string;
}
export class SubVertical {
    subverticalid: number;
    verticalname: string;
    subverticalname: string;
    createdon: String;
    activeflag: string;
}
export class Currency {
    currencyid: number;
    currencyname: string;
    createdon: String;
    activeflag: string;
}
export class GlobalMessage {
    downloadexcel_text = "Please download this Excel data. It will be saved in your Download directory by default."
    excelformate_text = "Please download this Excel Format. It will be saved in your Download directory by default. Please check for the latest file that is downloaded since Excel does a version control if the file with the same name exists. Open the Excel file and enter the requested information in the columns provided."

}
export class Contrycodes {
    countryCodes = [
        { label: '+1 (US)', value: '+1' },
        { label: '+91 (IN)', value: '+91' },
        { label: '+44 (UK)', value: '+44' },
        { label: '+61 (AU)', value: '+61' }

        // Add more as needed
    ];
}
export class Versions {
    versionid: number;
    versionname: number;
}
export class Signatory {
    id: number;
}

export class Invalidfileextensions {

    id: number;
    orgid: number;
    fileextension: string;
    createdon: string;
    createdby: number;
    modifiedby: number;
    modifiedon: string;
    activeflag: string;
}
export class FilterVersion {
    tcategory = ''
    tproduct = ''
    tversionid = ''
    tfromdate = ''
    ttodate = ''
    page = 0
    size = 10
}

export class Scripts {
    id: number;
    productid: number;
    versionid: number;
    scriptname: number;
    requirementid: number;
    tablename: string;
    scriptdescription: string;
    scriptdata: string;
    scripttype: string;
    ismigration: string;
    deployeduat: string;
    deployedproduction: string;
    deployedenterprise: string;
    stage: string;
    createdon: string;
    createdby: number;
    modifiedby: number;
    modifiedon: string;

}